import * as damageConstants from "@store/damages/constants";


export const damageAddInformation = (payload) => ({ type: damageConstants.DAMAGE_ADD_INFO_REQUEST, payload });
export const damageAddInformationSuccess = (payload) => ({ type: damageConstants.DAMAGE_ADD_INFO_SUCCESS, payload });
export const damageAddInformationFail = (payload) => ({ type: damageConstants.DAMAGE_ADD_INFO_FAIL, payload });
